import { useState, useEffect } from 'react'
import { T } from './theme'

// App-wide floating cart bar. Reads 'syninn_activecart' from localStorage and
// shows restaurant name, item count and subtotal. Tapping calls onOpen(cart).
export default function CartNowBar({ onOpen }) {
  const [active, setActive] = useState(null)

  const read = () => {
    try {
      if (localStorage.getItem('syninn_hide_cartbar') === '1') { setActive(null); return }
      const raw = localStorage.getItem('syninn_activecart')
      if (!raw) { setActive(null); return }
      const a = JSON.parse(raw)
      if (a && a.count > 0) setActive(a)
      else setActive(null)
    } catch (e) { setActive(null) }
  }

  useEffect(() => {
    read()
    const interval = setInterval(read, 1200)
    window.addEventListener('focus', read)
    return () => { clearInterval(interval); window.removeEventListener('focus', read) }
  }, [])

  if (!active) return null

  return (
    <div
      onClick={() => onOpen && onOpen(active)}
      style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: '22px',
        width: 'auto',
        maxWidth: 'calc(100% - 40px)',
        zIndex: 99999,
        background: T.gold,
        borderRadius: '40px',
        padding: '12px 20px',
        boxShadow: '0 6px 24px rgba(201,168,76,0.45), 0 2px 8px rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
        cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <span style={{ fontSize: '22px' }}>🛒</span>
          <span style={{ position: 'absolute', top: '-6px', right: '-8px', background: '#080808', color: T.gold, fontSize: '10px', fontWeight: 700, borderRadius: '10px', padding: '1px 5px', minWidth: '16px', textAlign: 'center' }}>{active.count}</span>
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: '13px', color: '#080808', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{active.restaurantName}</div>
          <div style={{ fontSize: '11px', color: 'rgba(8,8,8,0.7)', fontWeight: 500 }}>
            {active.count} item{active.count !== 1 ? 's' : ''} · ₹{Math.round(active.subtotal || 0)} · {active.orderType === 'takeaway' ? 'Takeaway' : 'Delivery'}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, fontSize: '13px', color: '#080808', fontWeight: 700 }}>
        View Cart <span style={{ fontSize: '15px' }}>→</span>
      </div>
    </div>
  )
}